import React from 'react'
import Svg from '../../../components/Svg/Svg'
import { SvgProps } from '../../../components/Svg/types'

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 21 21" {...props}>
      <path
        d="M10.0352 0.615662C4.52344 0.615662 0.0351562 5.10394 0.0351562 10.6157C0.0351562 16.1274 4.52344 20.6157 10.0352 20.6157C15.5469 20.6157 20.0352 16.1274 20.0352 10.6157C20.0352 5.10394 15.5469 0.615662 10.0352 0.615662ZM15.6953 4.9516C17.1445 6.40082 18.0352 8.40082 18.0352 10.6157C18.0352 15.0453 14.4648 18.6157 10.0352 18.6157C7.82031 18.6157 5.82031 17.725 4.37109 16.2758L15.6953 4.9516Z"
        fill="#FDFDFD"
      />
    </Svg>
  )
}

export default Icon
